// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3y81P","comment":"styles_comment__1glv7"};